var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPuzzle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m241 512v-60.333h-7.583c-33.176 0-60.167-26.991-60.167-60.167s26.991-60.167 60.167-60.167h7.583v-60.333h-75.333c-8.284 0-15-6.716-15-15v-22.583c0-16.634-13.533-30.167-30.167-30.167s-30.167 13.533-30.167 30.167v22.583c0 8.284-6.716 15-15 15h-75.333v210.833c0 16.634 13.533 30.167 30.167 30.167z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m481.833 512c16.634 0 30.167-13.533 30.167-30.167v-210.833h-60.333v7.583c0 33.176-26.991 60.167-60.167 60.167s-60.167-26.991-60.167-60.167v-7.583h-60.333v75.333c0 8.284-6.716 15-15 15h-22.583c-16.634 0-30.167 13.533-30.167 30.167s13.533 30.167 30.167 30.167h22.583c8.284 0 15 6.716 15 15v75.333z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m391.5 308.75c16.634 0 30.167-13.533 30.167-30.167v-22.583c0-8.284 6.716-15 15-15h75.333v-210.833c0-16.634-13.533-30.167-30.167-30.167h-210.833v60.333h7.583c33.176 0 60.167 26.991 60.167 60.167s-26.991 60.167-60.167 60.167h-7.583v60.333h75.333c8.284 0 15 6.716 15 15v22.583c0 16.634 13.533 30.167 30.167 30.167z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m30.167 0c-16.634 0-30.167 13.533-30.167 30.167v210.833h60.333v-7.583c0-33.176 26.991-60.167 60.167-60.167s60.167 26.991 60.167 60.167v7.583h60.333v-75.333c0-8.284 6.716-15 15-15h22.583c16.634 0 30.167-13.533 30.167-30.167s-13.533-30.167-30.167-30.167h-22.583c-8.284 0-15-6.716-15-15v-75.333z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuzzle);
export default __webpack_public_path__ + "static/media/puzzle.b21bdbcfb0272aeefd50dad48f9bc3b3.svg";
export { ForwardRef as ReactComponent };